import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useSiteData } from "../../contexts/SiteDataContext";
import type { NavigationLink } from "../../types";
import Modal from "../Modal/Modal";

interface MobileMenuModalProps {
  navigationLinks: NavigationLink[];
}

function MobileMenuModal({ navigationLinks }: MobileMenuModalProps) {
  const { siteData, setSiteData } = useSiteData();
  const location = useLocation();
  const navigate = useNavigate();

  const close = () => {
    setSiteData({ ...siteData, isMobileMenuOpen: false });
  };

  const handleLinkClick = (
    link: NavigationLink,
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    event.preventDefault();

    if (link.onClick) {
      link.onClick(event);
      return;
    }

    close();

    if (!link.href.startsWith("#")) {
      navigate(link.href);
    }
  };

  const isCurrentPage = (href: string) => {
    return location.pathname === href;
  };

  return (
    <Modal
      isOpen={!!siteData.isMobileMenuOpen}
      onClose={close}
      id="mobile-menu-modal"
      closeIcon="dark"
    >
      <nav className="flex flex-col gap-8">
        {navigationLinks.map((link, index) => {
          const className = `button block text-[1.125rem] font-black leading-[1.25rem] tracking-[0.00625rem] rounded-[0.5rem] text-center py-[1.25rem] px-[4.375rem] ${
            link.isMobileHighlight ? "bg-yellow" : "bg-dark-4"
          } ${isCurrentPage(link.href) ? "" : ""}`;

          if (link.href.startsWith("#")) {
            return (
              <a
                key={index}
                href={link.href}
                onClick={(event) => handleLinkClick(link, event)}
                data-umami-event="Mobile Menu Link Click"
                className={className}
              >
                {link.label}
              </a>
            );
          }

          return (
            <Link
              key={index}
              to={link.href}
              onClick={(event) => handleLinkClick(link, event)}
              data-umami-event="Mobile Menu Link Click"
              className={className}
            >
              {link.label}
            </Link>
          );
        })}
      </nav>
    </Modal>
  );
}

export default MobileMenuModal;
